// NEW STYPEPARAMS METHOD
var CONTENT_LOAD_PLACEHOLDER = {
    BLUR: 'BLUR',
    COLOR: 'COLOR',
    MAIN_COLOR: 'MAIN_COLOR',
};
export default CONTENT_LOAD_PLACEHOLDER;
//# sourceMappingURL=behaviourParams_item_content_loader.js.map